import { Image, Menu, MenuProps } from "antd";
import Sider from "antd/es/layout/Sider";
import { MenuInfo } from "rc-menu/lib/interface";
import { useCallback, useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./SideBarMenu.module.scss";
import { Twirl as Hamburger } from "hamburger-react";
import spacing from "../../ui/spacingConfig";
import { useRole } from "../../../features/roles/useRole";

export const SideBarMenu: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAdmin } = useRole();
  const [isMobileSidebarVisible, setIsMobileSidebarVisible] = useState(false);

  const onMenuClick = useCallback(
    (e: MenuInfo) => {
      navigate(e.key);
      setIsMobileSidebarVisible(false);
    },
    [navigate],
  );

  const toggleSidebar = () => {
    setIsMobileSidebarVisible((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 765) {
        setIsMobileSidebarVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const menuItems: MenuProps["items"] = useMemo(() => {
    const items: MenuProps["items"] = [
      { key: "/", label: "Tableau de bord" },
      {
        key: "/pdca",
        label: "PDCA",
        children: [
          { key: "/events", label: "ÃvÃ©nements" },
          {
            key: "/gestion-audit",
            label: "Audits",
            children: [
              { key: "/audits", label: "Suivi audits" },
              { key: "/pdca/constat", label: "Suivi constats" },
            ],
          },
        ],
      },
    ];
    if (isAdmin) {
      items.push({
        key: "/parametres",
        label: "ParamÃ¨tres",
        children: [
          { key: "/parametres/utilisateurs", label: "Utilisateurs" },
          { key: "/parametres/themes", label: "ThÃ©matiques" },
          { key: "/parametres/types-audit", label: "Types d'audit" },
          { key: "/parametres/gravite-constat", label: "GravitÃ© constat" },
        ],
      });
      items.push({ key: "/extraction", label: "Extraction" });
    }
    return items;
  }, [isAdmin]);

  return (
    <>
      <div className={styles.hamburger}>
        <Hamburger
          size={spacing.sm}
          toggled={isMobileSidebarVisible}
          toggle={toggleSidebar}
          color={isMobileSidebarVisible ? "white" : "black"}
        />
      </div>
      <Sider
        width={200}
        theme="light"
        className={`${styles.root} ${isMobileSidebarVisible ? styles.mobileVisible : ""}`}
      >
        <div className={styles.logo}>
          <Image
            src={`${process.env.PUBLIC_URL}/images/logo-sdlp_white.png`}
            alt="SDLP Logo"
          />
        </div>
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          defaultOpenKeys={["/pdca", "/gestion-audit"]}
          items={menuItems}
          onClick={onMenuClick}
        />
      </Sider>
      {isMobileSidebarVisible && (
        <div className={styles.overlay} onClick={toggleSidebar} />
      )}
    </>
  );
};

export default SideBarMenu;
